import { Alert } from 'antd';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { DailyAdvancement } from 'business/dashboard/components/daily-advancement';
import { DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES } from 'business/dashboard/constants';
import { useDailyAdvancement } from 'business/dashboard/hooks/use-daily-advancement';
import { minutesToMilliseconds } from 'technical/time-utils/minutes-to-milliseconds';
import { useCurrentDate } from 'technical/time-utils/use-current-date';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';
import Loader from 'ui/loader';

const DailyAdvancementContainer = () => {
  const { currentConstructionSite } = useAppContext();
  const { t } = useTranslation();
  invariant(currentConstructionSite, 'No constructionSite id');

  const { currentDate: currentTimestamp } = useCurrentDate({
    refreshTimeout: minutesToMilliseconds(DASHBOARD_REFRESH_TIMEOUT_IN_MINUTES),
  });

  const distanceUnit = currentConstructionSite.distanceUnit;

  const { loading, error, dailyAdvancement } = useDailyAdvancement({
    currentTimestamp,
    constructionSiteId: currentConstructionSite.id,
    distanceUnit,
  });

  if (error) {
    return <Alert message={t('errors.error_generic')} type="error" />;
  }

  if (loading || isUndefinedOrNull(dailyAdvancement)) {
    return <Loader />;
  }

  return (
    <DailyAdvancement
      shift1Count={dailyAdvancement.shift1Count}
      shift2Count={dailyAdvancement.shift2Count}
      shift3Count={dailyAdvancement.shift3Count}
      shift1Defined={dailyAdvancement.shift1Defined}
      shift2Defined={dailyAdvancement.shift2Defined}
      shift3Defined={dailyAdvancement.shift3Defined}
      builtRings={
        dailyAdvancement.shift1Count +
        dailyAdvancement.shift2Count +
        dailyAdvancement.shift3Count
      }
      metricAdvancement={dailyAdvancement.metricAdvancement}
    />
  );
};

export default DailyAdvancementContainer;
